
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.222 3.111H5.778A1.78 1.78 0 004 4.89v14.222c0 .98.797 1.778 1.778 1.778h12.444A1.78 1.78 0 0020 19.111V4.89a1.78 1.78 0 00-1.778-1.778zm-12.444 16V4.89h12.444l.001 14.222H5.778z"}}),_c('path',{attrs:{"d":"M7.555 12h1.778v1.777H7.555V12zm0 3.555h1.778v1.778H7.555v-1.778zm3.556-3.556h1.778v1.778H11.11V12zM7.555 6.666h8.89v3.556h-8.89V6.666zm3.556 8.889h1.778v1.778H11.11v-1.778zm3.555-3.556h1.778v5.334h-1.777v-5.334z"}})])
          )
        }
      }
    